import React from 'react';

import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import DefaultLimits from 'apps/auth/components/profile/limits/DefaultLimits';
import IndividualLimits from 'apps/auth/components/profile/limits/IndividualLimits';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_PROFILE } from 'apps/auth/constants/UrlConstants';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { toLowerCase } from 'apps/auth/helpers/utils';
import { useApp, useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';
import { LimitsService } from 'apps/auth/services/LimitsService';

const ProfileLimitInfoPage = () => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const { profile_form: profileForm, limits, alarmLimits } = useExtra();
    const messages = usePageMessages();
    const businessLimit = LimitsService.findBusinessLimits(profileForm);
    const hasBusinessLimits = Object.keys(businessLimit).length > 0;

    if (!profileForm || !limits) {
        return null;
    }

    return (
        <CommonPage backUrl={AUTH_PROFILE}>
            <HeaderPanel title={messages.gaLimitsTitle} />
            <IndividualLimits
                title={hasBusinessLimits ? messages.profileIndividualLimitsTitle : messages.customLimitsBlockTitle}
                lang={lang}
                country={country}
            />
            {hasBusinessLimits && (
                <DefaultLimits
                    title={messages.profileBusinessLimitsTitle}
                    progressWidth={businessLimit.usedPercent}
                    isExhaustedLimit={alarmLimits < businessLimit.usedPercent}
                    currency={toLowerCase(businessLimit.currencyCode)}
                    spendSum={getLocalizedRawAmount(lang, country, businessLimit.used)}
                    spendText={messages.spent}
                    leftSum={getLocalizedRawAmount(lang, country, businessLimit.max - businessLimit.used)}
                    leftText={businessLimit.totalLimitEnd ? messages.profileBusinessLimitExpires : null}
                    isLimitError={businessLimit.max === 0}
                    limitErrorText={messages.profileLimitFrodError}
                />
            )}
        </CommonPage>
    );
};
export default BasePage(ProfileLimitInfoPage);
